<section class="trend-grid">
  <div class="tstat">
    <div class="lbl">Avg. Compliance (12 mo)</div>
    <div class="val green">{{ stats.avgCompliance12mo }}%</div>
    <div
      class="delta"
      [class.up]="stats.avgComplianceDeltaVsPriorYear >= 0"
      [class.down]="stats.avgComplianceDeltaVsPriorYear < 0"
    >
      {{ stats.avgComplianceDeltaVsPriorYear >= 0 ? '▲' : '▼' }} {{ absVal(stats.avgComplianceDeltaVsPriorYear) }}% vs
      prior year
    </div>
  </div>
  <div class="tstat">
    <div class="lbl">Current Compliance</div>
    <div class="val green">{{ stats.currentCompliance }}%</div>
    <div
      class="delta"
      [class.up]="stats.currentComplianceDeltaMoM >= 0"
      [class.down]="stats.currentComplianceDeltaMoM < 0"
    >
      {{ stats.currentComplianceDeltaMoM >= 0 ? '▲' : '▼' }} {{ absVal(stats.currentComplianceDeltaMoM) }}% MoM
    </div>
  </div>
  <div class="tstat">
    <div class="lbl">Missing Patches</div>
    <div class="val red">{{ stats.missingPatches | number }}</div>
    <div class="delta" [class.up]="stats.missingPatchesDeltaMoM >= 0" [class.down]="stats.missingPatchesDeltaMoM < 0">
      {{ stats.missingPatchesDeltaMoM >= 0 ? '▲' : '▼' }} {{ absVal(stats.missingPatchesDeltaMoM) }} MoM
    </div>
  </div>
  <div class="tstat">
    <div class="lbl">Devices in Cycle</div>
    <div class="val">{{ stats.devicesInCycle }}</div>
    <div class="delta" [class.up]="stats.devicesInCycleDeltaMoM >= 0" [class.down]="stats.devicesInCycleDeltaMoM < 0">
      {{ stats.devicesInCycleDeltaMoM >= 0 ? '▲' : '▼' }} {{ absVal(stats.devicesInCycleDeltaMoM) }} MoM
    </div>
  </div>
</section>

<div class="card chart-card">
  <h3 class="card__title card__title--left">Patch Compliance Trend</h3>
  @if (trend.length > 0) {
    <div class="legend legend--left">
      <span><i style="background: #00c100"></i>Installed</span>
      <span><i style="background: #b9bbbc"></i>Missing</span>
      <span><i style="background: #21b3ff; border-radius: 50%"></i>Compliance %</span>
      <span class="note">Last 12 Months</span>
    </div>
    <div class="chart-area">
      <canvas baseChart [type]="'bar'" [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins"></canvas>
    </div>
  } @else {
    <div class="empty-state-content">
      <mat-icon class="empty-state-icon">bar_chart</mat-icon>
      <h4 class="empty-state-title">No Patch Data</h4>
    </div>
  }
</div>
